<template>
	<div class="input-group my-3">
		<input
			type="text"
			class="form-control"
			placeholder="Search Friend"
		>
		<div class="input-group-append">
			<button class="" type="button">Add</button>
		</div>
	</div>
</template>

<script>
	export default {
	    components: {

	    },
	    props: {

	    },
	    data() {
	        return {

	        }
	    }
	}
</script>

<style lang="scss" scoped>
	input {
		border-radius: 0;
		background-color: rgba(white, 0.7);
		border-bottom: 1px solid #888678;
	}

	button {
		background-color: #e2e0cf;
		// border-bottom: 0;
		// border-right: 0;
		border-right: 1px solid #888678;
		border-top-color: white;
		border-top-width: 1px;
		border-bottom: 1px solid #888678;
		padding: rem-calc(5 12);
		text-transform: uppercase;
	}

</style>